export const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));
export const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
export const fmt = (t: number) => {
  if (!isFinite(t) || t < 0) t = 0;
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = Math.floor(t % 60);
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};
